import {
  FlexBox,
  MediaPlayer,
  Modal,
  ModalBody,
  ModalHead,
  Spinner,
} from '@dixa/lib-shared-habla';
import { createAuthorizationHeaderValue } from 'lib-shared-auth';
import { config } from 'lib-shared-backend-config';
import { useEffect, useState } from 'react';

import styles from '../style/video-lightbox.module.scss';

type VideoLightboxProps = {
  url: string;
  fileName: string;
  className: string;
  onClose: () => void;
};

function isPrivate(url: string) {
  return url.includes(`${config.url.files}/private`);
}

export default function VideoLightbox({
  url,
  fileName,
  className,
  onClose,
}: VideoLightboxProps): JSX.Element {
  console.log(url, fileName);
  const [videoType, setVideoType] = useState('');
  const [loadingStatus, setLoadingStatus] = useState('succeeded');

  const fetchFileBlob = async (url: string) => {
    const basicAuth = await createAuthorizationHeaderValue();

    return new Promise((resolve, reject) => {
      if (!url) {
        console.log('URL WAS NULL!');
        reject();
      }
      const headers = new Headers();
      if (isPrivate(url)) {
        headers.append('Authorization', basicAuth);
      }

      const request = {
        method: 'GET',
        headers,
        mode: 'cors',
        cache: 'no-cache',
      };

      fetch(url, request as any)
        .then((response) => {
          for (const pair of response.headers.entries()) {
            console.log(pair);
            if (pair[0] === 'content-type') {
              setVideoType(pair[1]);
              break;
            }
          }
          return response.blob();
        })
        .then((blob) => {
          resolve(blob);
        })
        .catch((e) => {
          console.log('Error', e);
          reject(e);
        });
    });
  };

  useEffect(() => {
    loadPreview(url);
  }, [url]);

  const loadPreview = (url) => {
    setVideoType('');
    setLoadingStatus('loading');

    try {
      fetchFileBlob(url)
        .then((blob) => {
          setLoadingStatus('succeeded');
        })
        .catch((e) => {
          console.error('ERROR fetchFileBlob', e);
          setLoadingStatus('failed');
          setVideoType('');
        });
    } catch (e) {
      console.log('Error', e);
    }
  };

  return (
    <Modal
      isOpen={videoType !== '' || loadingStatus === 'loading'}
      allowClickOutside
      allowEscClose
      className={className}
      onClose={onClose}
    >
      <ModalHead title={fileName} onClose={onClose} />
      <ModalBody className={styles.xlsxLightbox}>
        <FlexBox justifyContent="center">
          {loadingStatus === 'loading' && <Spinner size={32} />}
        </FlexBox>
        <FlexBox justifyContent="center">
          <MediaPlayer
            className={styles.videoLightbox}
            mediaFile={{ src: url, type: videoType }}
            isPrivateFile={isPrivate(url)}
          />
        </FlexBox>
      </ModalBody>
    </Modal>
  );
}
